// Servicio para consumir la API de solicitudes
export async function obtenerSolicitudesPublicadas() {
  const res = await fetch('/APIbridge/solicitudes/publicadas');
  if (!res.ok) throw new Error('Error al obtener solicitudes');
  return await res.json();
}

export async function obtenerDetalleSolicitud(consecutivo) {
  const res = await fetch(`/APIbridge/solicitudes/${consecutivo}`);
  if (!res.ok) throw new Error('Error al obtener detalle de solicitud');
  return await res.json();
}

export async function obtenerParticipacionesProveedor(cedula) {
  const res = await fetch(`/APIbridge/proveedores/${cedula}/participaciones`);
  if (!res.ok) throw new Error('Error al obtener participaciones');
  return await res.json();
}

export async function crearProveedor(data) {
  const res = await fetch('/APIbridge/proveedores', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error('Error al crear proveedor');
  return await res.json();
}

export async function obtenerDetallePropuesta(consecutivo) {
  const res = await fetch(`/APIbridge/propuestas/detalle/${consecutivo}`);
  if (!res.ok) throw new Error('Error al obtener detalle de propuesta');
  return await res.json();
}

export async function crearPropuesta(data) {
  const res = await fetch('/APIbridge/propuestas', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    let errorMsg = 'Error al crear propuesta';
    try {
      const errorData = await res.json();
      if (errorData && errorData.message) errorMsg = errorData.message;
      else if (typeof errorData === 'string') errorMsg = errorData;
    } catch {
      errorMsg = await res.text();
    }
    throw new Error(errorMsg);
  }
  return await res.json();
}

// Obtener proveedor por cédula
export async function obtenerProveedorPorCedula(cedula) {
  const res = await fetch('/APIbridge/proveedores');
  if (!res.ok) throw new Error('Proveedor no existe');
  const proveedores = await res.json();
  return proveedores.find(p => p.cedulaJuridica === cedula) || null;
}
